import { Fragment } from "react";
import { ArrowRight } from "lucide-react";

import { cn } from "@/lib/utils";

interface CareerPathProps {
  /** Ordered step labels (Agent → Senior agent → … → Equity partner). */
  steps: string[];
}

/**
 * The career-path stepper — pills with arrow separators, the final step in teal.
 * The small production equivalent of the prototype's hand-rolled `CareerPath`;
 * tokens / Tailwind only.
 */
const CareerPath = ({ steps }: CareerPathProps) => (
  <div className="flex flex-wrap items-center gap-2">
    {steps.map((step, i) => {
      const isLast = i === steps.length - 1;
      return (
        <Fragment key={`${step}-${i}`}>
          <span
            className={cn(
              "whitespace-nowrap rounded-full border px-3.5 py-2 text-[13.5px] font-semibold",
              isLast
                ? "border-primary bg-primary-tint text-primary-pressed"
                : "border-border bg-card text-ink-700",
            )}
          >
            {step}
          </span>
          {!isLast && <ArrowRight className="h-4 w-4 shrink-0 text-ink-400" strokeWidth={2} />}
        </Fragment>
      );
    })}
  </div>
);

export default CareerPath;
